import { useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import back_app from '../../lib/back_app'

export default function EmailVerify() {
  const { user: auth0_user, logout } = useAuth0()
  const [sending, set_sending] = useState(false)
  const [sent, set_sent] = useState(false)
  const [err, set_err] = useState<string | null>(null)
  const email = auth0_user?.email || ''

  const handle_resend = async () => {
    set_sending(true)
    set_err(null)
    try {
      let res = await back_app.user_email_resend(email)
      if (res?.err) {
        set_err(res.err)
        return
      }
      set_sent(true)
    } catch (e: any) {
      set_err(e?.message || 'failed to resend')
    } finally {
      set_sending(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-blue via-primary-purple to-primary-blue flex items-center justify-center px-4 py-8">
      <div className="max-w-lg w-full bg-white/95 backdrop-blur-lg rounded-3xl shadow-2xl p-8 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Email not verified</h1>
        <p className="text-gray-600 mb-6">
          We sent a verification link to <span className="font-semibold">{email}</span>.
          Please check your inbox and click the link to continue.
        </p>
        <div className="flex items-center justify-center gap-2 mb-6 text-sm text-gray-500">
          <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          Waiting for verification...
        </div>
        <button
          onClick={handle_resend}
          disabled={sending}
          className="w-full bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white py-3 rounded-xl font-bold hover:shadow-xl transition-all disabled:opacity-60"
        >
          {sending ? 'Sending...' : sent ? 'Verification email sent' : 'Resend verification email'}
        </button>
        {err && <p className="text-red-600 text-sm mt-3">{err}</p>}
        <button
          onClick={() => logout({logoutParams: {returnTo: window.location.origin}})}
          className="mt-6 text-sm text-gray-500 hover:text-gray-700 underline"
        >
          Sign out
        </button>
      </div>
    </div>
  )
}